import { assertNever } from "@syla/shared/types/helpers/errors";
import { DataSourceCode } from "@syla/shared/types/models/DataSourceBase";
import { getCoinBaseAuthoriseUrl } from "./getCoinBaseAuthoriseUrl";
import { getCoinJarAuthoriseUrl } from "./getCoinJarAuthoriseUrl";

export function getAuthoriseUrl({
  dataSourceCode,
  accountId,
  walletId,
}: {
  dataSourceCode: DataSourceCode.CoinJar | DataSourceCode.Coinbase;
  accountId: string;
  walletId: string;
}): string {
  if (dataSourceCode === DataSourceCode.CoinJar) {
    return getCoinJarAuthoriseUrl({ walletId, accountId });
  }

  if (dataSourceCode === DataSourceCode.Coinbase) {
    return getCoinBaseAuthoriseUrl({ walletId, accountId });
  }

  assertNever(dataSourceCode);
}
